import {
    getMerchantBalance,
    getMBHUpdatedStatusSummaryAll,
    addMerchantBalance,
    updateMerchantBalance,
    fetchMerchantBalanceById,
    getMerchantEscrowBalanceCount,
    getMerchantBalanceCount,
    getMerchantWalletBalance
  } from "../../services/MerchantBalance";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const MERCHANT_BALANCE_LIST_INITIATED = "MERCHANT_BALANCE_LIST_INITIATED";
  export const MERCHANT_BALANCE_INITIATED = "MERCHANT_BALANCE_INITIATED";
  export const MERCHANT_BALANCE_LIST_LOADED = "MERCHANT_BALANCE_LIST_LOADED";
  export const MERCHANT_MBH_BALANCE_LIST_INITIATED = "MERCHANT_MBH_BALANCE_LIST_INITIATED";
  export const MERCHANT_MBH_BALANCE_INITIATED = "MERCHANT_MBH_BALANCE_INITIATED";
  export const MERCHANT_MBH_BALANCE_LIST_LOADED = "MERCHANT_MBH_BALANCE_LIST_LOADED";
  export const MERCHANT_MBH_BALANCE_LIST_FAILED = "MERCHANT_MBH_BALANCE_LIST_FAILED";

  
  export const MERCHANT_BALANCE_LOADED = "MERCHANT_BALANCE_LOADED";
  export const MERCHANT_BALANCE_FAILED = "MERCHANT_BALANCE_FAILED";
  export const MERCHANT_WALLET_BALANCE_INITATED = "MERCHANT_WALLET_BALANCE_INITATED";
  export const MERCHANT_WALLET_BALANCE_LOADED = "MERCHANT_WALLET_BALANCE_LOADED";
  export const MERCHANT_WALLET_BALANCE_FAILED = "MERCHANT_WALLET_BALANCE_FAILED";
  export const MERCHANT_BALANCE_COUNT_INITIATED = "MERCHANT_BALANCE_COUNT_INITIATED";
  export const MERCHANT_BALANCE_COUNT_LOADED = "MERCHANT_BALANCE_COUNT_LOADED";
  export const MERCHANT_BALANCE_COUNT_FAILED  = "MERCHANT_BALANCE_COUNT_FAILED";
  export const MERCHANT_ESCROW_BALANCE_COUNT_INITIATED = "MERCHANT_ESCROW_BALANCE_COUNT_INITIATED";
  export const MERCHANT_ESCROW_BALANCE_COUNT_LOADED = "MERCHANT_ESCROW_BALANCE_COUNT_LOADED";
  export const MERCHANT_ESCROW_BALANCE_COUNT_FAILED  = "MERCHANT_ESCROW_BALANCE_COUNT_FAILED";
  
  export const loadMerchantBalance = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BALANCE_LIST_INITIATED });
      getMerchantBalance(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_BALANCE_LIST_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BALANCE_FAILED, payload: error.message });
        });
    };
  };


  export const loadMBHUpdatedStatusSummaryAll = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_MBH_BALANCE_LIST_INITIATED });
      getMBHUpdatedStatusSummaryAll(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_MBH_BALANCE_LIST_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_MBH_BALANCE_LIST_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantWalletBalance = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_WALLET_BALANCE_INITATED });
      getMerchantWalletBalance(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_WALLET_BALANCE_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_WALLET_BALANCE_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantBalanceCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_ESCROW_BALANCE_COUNT_INITIATED });
      getMerchantEscrowBalanceCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_ESCROW_BALANCE_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_ESCROW_BALANCE_COUNT_FAILED, payload: error.message });
        });
    };
  };

    export const loadBalanceCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BALANCE_COUNT_INITIATED });
      getMerchantBalanceCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_BALANCE_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BALANCE_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getMerchantBalanceById = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BALANCE_INITIATED });
      return fetchMerchantBalanceById(id)
        .then((response) => {
          dispatch({ type: MERCHANT_BALANCE_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BALANCE_FAILED, payload: formatError(error) });
        });
    };
  };
  
  export const saveMerchantBalanceAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BALANCE_INITIATED });
      const apiCall = isEdit ? updateMerchantBalance(id, data) : addMerchantBalance(data);
      return apiCall
        .then((response) => {
          formatSuccess('Fund Request', response.data)
          setTimeout(()=>{
            navigate('/fund-requests');
          },1000)
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: MERCHANT_BALANCE_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: MERCHANT_BALANCE_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };